import { usePage } from "@inertiajs/react"
import { UserLayout } from "@/components/layouts/user-layout"
import { ReceiptScreen } from "@/features/user/receipt-screen"
import type { BillDetailed } from "@/features/user/types"

type Props = {
  bill: BillDetailed
}

export default function UserBillsReceipt() {
  const { bill } = usePage<Props>().props

  // A receipt can be for a bill the diner already left, so it names its own
  // location rather than the current visit's.
  return (
    <UserLayout locationName={bill.locationName}>
      <ReceiptScreen bill={bill} />
    </UserLayout>
  )
}
